import BaseBookingSave from "@/classes/models/BaseBookingSave";

export function useMapBookingSave(viewModel, bookingType) {

    // BaseBooking has basic id & job No. bookingSaveDetail is built on the fly below by adding the props fro the model
    let bookingSaveDetail = new BaseBookingSave();

    bookingSaveDetail.id = viewModel.id;
    bookingSaveDetail.jobNumber = viewModel.jobNumber;

    bookingSaveDetail.shipper = JSON.parse(JSON.stringify(viewModel.shipper));
    bookingSaveDetail.shipper.shipperCountry = bookingSaveDetail.shipper.shipperCountry ?.split('-')[0];
    bookingSaveDetail.shipper.shipperName = bookingSaveDetail.shipper.shipperName ?.split('-')[0].trim();
    delete bookingSaveDetail.shipper.shipperContacts;

    bookingSaveDetail.consignee = JSON.parse(JSON.stringify(viewModel.consignee));
    bookingSaveDetail.consignee.consigneeCountry = bookingSaveDetail.consignee.consigneeCountry ?.split('-')[0];
    bookingSaveDetail.consignee.consigneeName = bookingSaveDetail.consignee.consigneeName ?.split('-')[0].trim();
    delete bookingSaveDetail.consignee.consigneeContacts;

    bookingSaveDetail.dimensions = JSON.parse(JSON.stringify(viewModel.dimensions));

    // Set the unit of measure value in text for the service from the UI switch bool value
    viewModel.unitOfMeasureSwitch ? bookingSaveDetail.dimensions.unitOfMeasure = 'imperial' :
        bookingSaveDetail.dimensions.unitOfMeasure = 'metric';

    bookingSaveDetail.dimensions.totalPieces = bookingSaveDetail.dimensions.totalPieces ?.toString();
    bookingSaveDetail.dimensions.chargeableWeight = bookingSaveDetail.dimensions.chargeableWeight ?.toString();

    bookingSaveDetail.files = viewModel.files;

    if(bookingType === 'freightBooking') {

        bookingSaveDetail.shipment = JSON.parse(JSON.stringify(viewModel.shipment));
        bookingSaveDetail.shipment.shipmentCurrency = bookingSaveDetail.shipment.shipmentCurrency ?.split('-')[0];
        bookingSaveDetail.shipment.shipmentBillingParty = viewModel.shipment.shipmentBillingPartyId ? viewModel.shipment.shipmentBillingPartyId : '';
        delete bookingSaveDetail.shipment.shipmentBillingPartyId;
    }

    if(bookingType === 'courierBooking') {

        bookingSaveDetail.consignment = JSON.parse(JSON.stringify(viewModel.consignment));
        bookingSaveDetail.customs = viewModel.customs;
        bookingSaveDetail.customsComments = viewModel.customsComments;
        bookingSaveDetail.consignment.currency = bookingSaveDetail.consignment.currency ?.split('-')[0];
    }

    if(bookingType === 'preJobAir') preJobMappingFactory('flightShipment');
    if(bookingType === 'preJobSea') preJobMappingFactory('seaShipment');
    if(bookingType === 'preJobRoad') preJobMappingFactory('roadShipment');
    if(bookingType === 'preJobRail') preJobMappingFactory('railShipment');

    function preJobMappingFactory(section) {

        bookingSaveDetail[section] = JSON.parse(JSON.stringify(viewModel[section]));
        bookingSaveDetail[section].currency =  bookingSaveDetail[section].currency ?.split('-')[0];
        bookingSaveDetail[section].placeOfReceipt = bookingSaveDetail[section].placeOfReceiptId ?.trim();
        bookingSaveDetail[section].originPort = bookingSaveDetail[section].originPortId ?.trim();
        bookingSaveDetail[section].destinationPort = bookingSaveDetail[section].destinationPortId ?.trim();
        bookingSaveDetail[section].finalDestination = bookingSaveDetail[section].finalDestinationId ?.trim();
        bookingSaveDetail[section].shipperRef = viewModel.shipper.shipperRef;
        bookingSaveDetail[section].consigneeRef = viewModel.consignee.consigneeRef;
        bookingSaveDetail[section].consigneeRefAdditional = viewModel.consignee.additionalRef;

        bookingSaveDetail[section].cube = viewModel.dimensions.cube;

        viewModel.cubeUnitSwitch ? bookingSaveDetail.cubeUnit = 'feet' :
            bookingSaveDetail.cubeUnit = 'meters'
    }

    return(bookingSaveDetail);

}
